import { axiosInstance, axiosFileBlob, live_instance, axiosFileBlob_live } from "../instance"

/**===================================================动态主题===================================================== */
// 获取动态主题列表
export const getDynamicTopicListApi = (params) => live_instance({method: 'get', url: `/vod-operation/dynamicTheme/page`, params})

// 添加动态主题
export const addDynamicTopicListApi = (data) => live_instance({method: 'post', url: `/vod-operation/dynamicTheme`, data, type: 'json'})

// 删除动态主题
export const deleteDynamicTopicListApi = (themeId) => live_instance({method: 'delete', url: `/vod-operation/dynamicTheme`, params: {themeId} })

//修改动态主题
export const editDynamicTopicListApi = (data) => live_instance({method: 'put', url: `/vod-operation/dynamicTheme`, data, type: 'json'})

// 根据终端类型获取模板列表
export const getTerminalTemplateListApi = (clientType) => live_instance({method: 'get', url: `/vod-operation/dynamic/template/list`, params: {clientType}})

// 获取主题绑定的模板列表
export const getDynamicThemeListApi = (themeId) => live_instance({method: 'get', url: `/vod-operation/dynamic/theme/template/list`, params: { themeId } })

// 编辑主题模板
export const editDynamicThemeListApi = (data) => live_instance({method: 'post', url: `/vod-operation/dynamic/theme/template`, data, type: 'json'})


/**==================================================运营方案管理================================================================== */
// 添加动态运营方案
export const addDynamicPlanApi = (data) => live_instance({method: 'post', url: `/vod-operation/dynamic/plan`, data, type: 'json'})

// 删除动态运营方案
export const deleteDynamicPlanApi = (planId) => live_instance({method: 'delete', url: `/vod-operation/dynamic/plan`, params: {planId} })

// 修改动态运营方案
export const editDynamicPlanApi = (data) => live_instance({method: 'put', url: `/vod-operation/dynamic/plan`, data, type: 'json'})

// 修改动态主题排序
export const editDynamicPlanSequenceApi = (params) => live_instance({method: 'put', url: `/vod-operation/dynamic/plan/theme/sort`, params, })

// 获取动态运营方案列表
export const getDynamicPlanListApi = (params) => live_instance({method: 'get', url: `/vod-operation/dynamic/plan/page`, params})

// 获取动态主题列表 
export const getDynamicThemeApi = (params) => live_instance({method: 'get', url: `/vod-operation/dynamicTheme/list`, params})

// 获取运营方案列表(下拉列表) 
export const getDynamicOperationPlanApi = () => live_instance({method: 'get', url: `/vod-operation/dynamic/plan/list`})

// 获取动态运营方案绑定的主题
export const getBindingPlanListApi = (planId) => live_instance({method: 'get', url: `/vod-operation/dynamic/plan/theme/list`, params: {planId} })

// 获取动态方案的主题 
export const getDynamicPlanThemeApi = (params) => live_instance({method: 'get', url: `/vod-operation/recommend/vodplus/dynamic/plan/theme/list`, params })

// 添加子品牌动态方案
export const addDynamicPlanThemeApi = (data) => live_instance({method: 'post', url: `/vod-operation/recommend/vodplus/dynamic/plan`, data, type: 'json'})

// 编辑子品牌动态方案
export const editDynamicPlanThemeApi = (data) => live_instance({method: 'put', url: `/vod-operation/recommend/vodplus/dynamic/plan`, data, type: 'json'})

// 删除子品牌动态方案
export const deleteDynamicPlanThemeApi = (vodplusDynamicOperationPlanId) => live_instance({method: 'delete', url: `/vod-operation/recommend/vodplus/dynamic/plan`, params: {vodplusDynamicOperationPlanId}})

// 更新动态方案的主题 ---运营主题设置页面使用
export const updateDynamicPlanThemeApi = (data) => live_instance({method: 'put', url: `/vod-operation/recommend/vodplus/dynamic/plan/theme`, data, type: 'json'})

// 获取动态方案主题控件
export const getDynamicPlanItemListApi = (params) => live_instance({method: 'get', url: `/vod-operation/recommend/vodplus/dynamic/theme/component/list`, params })

// 编辑动态方案主题推荐位
export const editDynamicPlanRecommendApi = (data) => live_instance({method: 'post', url: `/vod-operation/recommend/vodplus/dynamic/theme/component/item`, data, type: 'json'})

// 编辑/更新主题控件标题
export const editThemeTitleApi = (data) => live_instance({method: 'put', url: `/vod-operation/recommend/vodplus/dynamic/theme/component/title`, data, type: 'json'})

// 获取关联分类的影片属性
export const getAssociateGenresApi = (categoryId) => live_instance({method: 'get', url: `/vod-content/category/${categoryId}/genres/list` })

// 添加子推荐位
export const addDynamicPlanThemeSubitemApi = (data) => live_instance({method: 'post', url: `/vod-operation/recommend/vodplus/dynamic/theme/component/item/sub`, data, type: 'json'})

// 编辑子推荐位
export const editDynamicPlanThemeSubitemApi = (data) => live_instance({method: 'put', url: `/vod-operation/recommend/vodplus/dynamic/theme/component/item/sub`, data, type: 'json'})

// 复制子推荐位
export const copyDynamicPlanThemeSubitemApi = (data) => live_instance({method: 'post', url: `/vod-operation/recommend/vodplus/dynamic/theme/component/item/sub/copy`, data, type: 'json'})

// 删除子推荐位
export const deleteDynamicPlanThemeSubitemApi = (id) => live_instance({method: 'delete', url: `/vod-operation/recommend/vodplus/dynamic/theme/component/item/sub`, params: {id}, })

// 切换动态推荐位
export const switchDynamicPlanRecommendApi = (data) => live_instance({method: 'put', url: `/vod-operation/recommend/vodplus/dynamic/theme/component/item/dynamicRecommend`, data, type: 'json'})




/**=============================================================动态方案主题推荐位的计划================================================================================== */
// 获取推荐位的计划
export const getDynamicPlanThemeItemApi = (params) => live_instance({method: 'get', url: `/vod-operation/recommend/vodplus/dynamic/theme/component/item/schedule/page`, params})

// 编辑推荐位的计划
export const editDynamicPlanThemeItemApi = (data) => live_instance({method: 'put', url: `/vod-operation/recommend/vodplus/dynamic/theme/component/item/schedule`, data, type: 'json'})

// 新增推荐位的计划
export const addDynamicPlanThemeItemApi = (data) => live_instance({method: 'post', url: `/vod-operation/recommend/vodplus/dynamic/theme/component/item/schedule`, data, type: 'json'})

// 删除推荐位的计划
export const deleteDynamicPlanThemeItemApi = (data) => live_instance({method: 'delete', url: `/vod-operation/recommend/vodplus/dynamic/theme/component/item/schedule`, data, type: 'json'})

// 上传、编辑和删除推荐位计划的图片
export const uploadDynamicPlanThemeItemImgApi = (data) => live_instance({method: 'post', url: `/vod-operation/recommend/vodplus/dynamic/theme/component/item/schedule/picture`, data, type: 'json'})

// 更新动态主题配置
export const updateDynamicPlanConfiApi = (data) => live_instance({method: 'put', url: `/vod-operation/recommend/vodplus/dynamic/theme/component/config`, data, type: 'json'})

// 上传推荐位对应的图片
export const uploadDynamicItemImgApi = (data) => live_instance({method: 'post', url: `/vod-operation/recommend/vodplus/dynamic/theme/component/item/category/picture`, data, type: 'json'})




